import { environment } from '../../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('PlanService', PlanService);

  PlanService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'TranslationModalService',
    'WindowModalService',
  ];

  function PlanService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    TranslationModalService,
    WindowModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'plans';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getPlans: getPlans,
      getPlan: getPlan,
      savePlan: savePlan,
      openPlanTranslations: openPlanTranslations,
      changePlanStatus: changePlanStatus,
      updatePlans: updatePlans,
      groupPlanFeaturesByCategory: groupPlanFeaturesByCategory,
      openPlanInfoModal: openPlanInfoModal,
      removePlanAddon: removePlanAddon,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filterCriteria = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filterCriteria;
    }

    function getPlans(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getPlan(id, language) {
      var params = { lang: null };

      if (language) {
        params.lang = language;
      }

      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        params,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function savePlan(item, language) {
      var itemAddedMsg = $translate('NEW_ADDED_PLAN');
      var itemAddedFlashMsg =
        $translate('PLAN_ADDED_MSG') + ' ' + $translate('REMEMBER_ADD_TRANSLATIONS');
      var itemModifiedMsg = $translate('MODIFIED_PLAN');

      var method = item.id ? 'put' : 'post';
      var url = item.id ? apiUrl + '/' + item.id : apiUrl;

      var lang = language ? language : config.DEFAULT_CONTENT_LANGUAGE;

      function success(response) {
        var msg = item.id ? itemModifiedMsg : itemAddedMsg;
        utils._successMsg(msg);

        if (!item.id) {
          // Create
          utils._setFlashMessage(itemAddedFlashMsg);
        }

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(method, url, { plan: item, lang: lang }, success, failure);
    }

    function openPlanTranslations(item, additionalLanguages) {
      var template = './app/ajs/admin/plans/modals/plan-detail-translation.html';

      var modalParams = {
        title: item.name,
        item: item,
        additionalLanguages: additionalLanguages,
      };

      var initializeCallback = function (itemId, language) {
        return getPlan(itemId, language).then(function (data) {
          return data;
        });
      };

      var confirmCallback = function (item, language) {
        // Prevent sending nil []
        delete item['plan_features'];
        delete item['plan_addons'];

        return savePlan(item, language).then(
          function () {
            return false;
          },
          function (response) {
            return response.data;
          }
        );
      };

      TranslationModalService.open(template, modalParams, initializeCallback, confirmCallback);
    }

    function changePlanStatus(item) {
      utils.changeItemStatus(apiUrl + '/' + item.id, item);
    }

    function updatePlans(action, items, successCallback) {
      utils.updateItems(apiUrl, action, items, successCallback);
    }

    function groupPlanFeaturesByCategory(items) {
      var featureCategoryList = [];
      items.forEach(function (item) {
        if (item.feature) {
          var featureCategoryId = item.feature.feature_category_id;

          if (!featureCategoryList[featureCategoryId]) {
            featureCategoryList[featureCategoryId] = {
              id: item.feature.feature_category.id,
              name: item.feature.feature_category.name,
              description: item.feature.feature_category.description,
              features: [],
            };
          }

          var value = item.feature.type === 'quantity' ? item.total_units : item.available;

          var feature = {
            id: item.id,
            name: item.feature.name,
            description: item.feature.description,
            type: item.feature.type,
            visible_as_addon: item.feature.visible_as_addon,
            feature_category_id: featureCategoryId,
            value: value, // Form feature,
            feature_id: item.feature.id, // Added
          };

          featureCategoryList[featureCategoryId].features.push(feature);
        }
      });

      var array = [];
      for (var key in featureCategoryList) {
        if (featureCategoryList.hasOwnProperty(key)) {
          var feature = featureCategoryList[key];
          array.push(feature);
        }
      }

      return array;
    }

    // Remove plan_addon
    function removePlanAddon(planId, planAddonId) {
      var url = apiUrl + '/' + planId + '/remove_plan_addon/' + planAddonId;
      return RestResource.request(
        'delete',
        url,
        {},
        function () {},
        function () {}
      );
    }

    function openPlanInfoModal(item) {
      var templateUrl = './app/ajs/admin/plans/modals/plan-info-modal.html';

      var modalParams = {
        title: 'PLAN_DETAILS',
        item: item,
      };

      WindowModalService.open(templateUrl, modalParams, {});
    }
  }
})();
